import 'Core/components/Dashboard/Dashboard.sass';
import React from 'react';
import AgentUserTypeEntry from 'Users/components/UserAdministration/UserEntry/Agent/AgentUserTypeEntry';
import {matchUserTypeByLineOfBusiness, UserType} from 'Users/models/User/UserType';
import QuotingUserTypeEntry from './Quoting/QuotingUserTypeEntry';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';

export type UserTypeEntryProps = {
  userType: UserType;
  isEdit: boolean;
  isExternal: boolean;
  isUserSupport: boolean;
};

const UserTypeEntry = (props: UserTypeEntryProps) => {
  const {userType, isEdit, isExternal} = props;

  const {BR_QuotingTool} = useSelector((state: ReducerState) => state.featureFlag);

  return matchUserTypeByLineOfBusiness(userType.value, {
    Agent: agentUserType => (
      <AgentUserTypeEntry agentUserType={agentUserType} isEdit={isEdit} isExternal={isExternal} />
    ),
    Quoting: quotingUserType => BR_QuotingTool ? ( <QuotingUserTypeEntry quotingEntryUserType={quotingUserType} isEdit={isEdit} />
    ): null,
  });
};

export default UserTypeEntry;
